import React, { useState, useEffect } from 'react'; // 1. Importamos useEffect
import config from '../../config/apiConfig';

const ConfiguracionNegocio = () => {
  const [nombre, setNombre] = useState('');
  const [logoActual, setLogoActual] = useState(null); // Para guardar el nombre del logo de la DB
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(true); // Empezamos cargando
  const [status, setStatus] = useState({ type: '', msg: '' });

  // URL donde se guardan tus imágenes en el servidor Flask
  const URL_LOGOS = config.api_url + "/static/logos/"; 

  // --- 2. JUGADA MAESTRA: LEER DATOS AL CARGAR ---
  useEffect(() => {
    const fetchNegocio = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await fetch(config.api_url + '/api/negocios/detalle', {
          headers: {'token':token }
        });
        const data = await response.json();
        console.log("datos lectura", data)
        if (response.ok) {
          setNombre(data.nombre || '');
          setLogoActual(data.logo); // Guardamos el nombre del archivo que viene de la DB
        }
      } catch (err) {
        console.error("Error al leer de la BD", err);
      } finally {
        setLoading(false);
      }
    };

    fetchNegocio();
  }, []);

  const handleImageChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      const reader = new FileReader();
      reader.onloadend = () => setPreview(reader.result);
      reader.readAsDataURL(selectedFile);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: 'info', msg: 'Guardando...' });

    const formData = new FormData();
    formData.append('nombre', nombre);
    if (file) formData.append('logo_file', file);

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(config.api_url +'/api/negocios/guardar', {
        method: 'POST',
        headers: {'token':token },
        body: formData
      });

      if (response.ok) {
        setStatus({ type: 'success', msg: '¡Configuración actualizada!' });
        // Opcional: podrías volver a llamar a la API para refrescar
      } else {
        setStatus({ type: 'danger', msg: 'Error al guardar cambios' });
      }
    } catch (err) {
      setStatus({ type: 'danger', msg: 'Error de conexión' });
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="text-center p-5">Cargando datos del negocio...</div>;

  return (
    <div className="container-fluid py-4" style={{ backgroundColor: '#f4f7f6', minHeight: '100vh' }}>
      <div className="row justify-content-center">
        <div className="col-12 col-xl-10">
          
          <div className="d-flex align-items-center justify-content-between mb-4 bg-white p-4 shadow-sm rounded">
            <div>
              <h2 className="mb-0 font-weight-bold text-dark">Identidad del Negocio</h2>
              <p className="text-muted mb-0">Gestiona el nombre y la imagen corporativa</p>
            </div>
            <button 
              form="form-negocio"
              type="submit" 
              className="btn btn-primary btn-lg px-5 shadow-sm"
              disabled={loading}
            >
              {loading ? <span className="spinner-border spinner-border-sm mr-2"></span> : <i className="fas fa-save mr-2"></i>}
              Guardar Cambios
            </button>
          </div>

          <div className="row">
            <div className="col-md-7 col-lg-8 mb-4">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body p-4">
                  <h5 className="card-title font-weight-bold mb-4">Datos Generales</h5>
                  <form id="form-negocio" onSubmit={handleSubmit}>
                    <div className="form-group">
                      <label className="font-weight-bold text-secondary">Nombre Comercial</label>
                      <input
                        type="text"
                        className="form-control form-control-lg border-light bg-light"
                        style={{ borderRadius: '10px' }}
                        value={nombre}
                        onChange={(e) => setNombre(e.target.value)}
                        required
                      />
                    </div>
                    {status.msg && (
                      <div className={`alert alert-${status.type} border-0 mt-4 shadow-sm`}>
                        {status.msg}
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>

            <div className="col-md-5 col-lg-4 mb-4">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body p-4 text-center">
                  <h5 className="card-title font-weight-bold mb-4 text-left">Logo Actual</h5>
                  
                  <div className="position-relative d-inline-block w-100" 
                    style={{ height: '250px', backgroundColor: '#f8f9fa', border: '2px dashed #dee2e6', borderRadius: '15px', overflow: 'hidden' }}>
                    
                    {/* LÓGICA DE VISUALIZACIÓN */}
                    {preview ? (
                      <img src={preview} className="w-100 h-100" style={{ objectFit: 'contain', padding: '15px' }} />
                    ) : logoActual ? (
                      <img src={URL_LOGOS + logoActual} className="w-100 h-100" style={{ objectFit: 'contain', padding: '15px' }} />
                    ) : (
                      <div className="h-100 d-flex flex-column align-items-center justify-content-center text-muted">
                        <i className="fas fa-cloud-upload-alt fa-3x mb-3"></i>
                        <p className="small">Haz click para subir logo</p>
                      </div>
                    )}
                    
                    <input
                      type="file"
                      className="position-absolute h-100 w-100"
                      style={{ top: 0, left: 0, opacity: 0, cursor: 'pointer' }}
                      accept="image/*"
                      onChange={handleImageChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfiguracionNegocio;